/* eslint-disable react/prop-types */
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import DataTable from "../../../components_reefer/Tables/DataTable/index";
// Data
import data from "./data/index";

function Projects({ patios }) {
  const { columns, rows } = data(patios);

  return (
    <Card>
      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
      </MDBox>
    </Card>
  );
}

export default Projects;
